module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Alterar Dados")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row border-row row-fix"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "content-box-small margin-t10"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger margin-t20",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")]) : _vm._e(), _vm._v(" "), (this.$route.params.type == 'UPDATE_USER_EMAIL') ? _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doChange.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group margin-b20",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "chooseEmailId"
    }
  }, [_vm._v("Novo e-mail")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-plate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "Digite o novo e-email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("email")) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('newEmail')
    }
  }, [_c('label', {
    attrs: {
      "for": "chooseEmailId"
    }
  }, [_vm._v("confirmar novo e-mail")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-plate"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('confirmed:email'),
      expression: "'confirmed:email'"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "newEmail",
      "placeholder": "Digite seu novo e-mail",
      "maxlength": "50",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("newEmail")) + "\n                ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    attrs: {
      "id": "btn-new-pass",
      "type": "button",
      "name": "button",
      "disabled": _vm.email != _vm.newEmail
    },
    on: {
      "click": _vm.doChange
    }
  }, [_vm._v("\n                Definir novo E-mail\n              ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })]) : _vm._e(), _vm._v(" "), (this.$route.params.type == 'UPDATE_USER_PHONE') ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doChange.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('oldCellPhone')
    }
  }, [_c('label', {
    attrs: {
      "for": "chooseEmailId"
    }
  }, [_vm._v("Novo celular")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-plate"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|cell'),
      expression: "'required|cell'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.oldCellPhone),
      expression: "oldCellPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "phone",
      "name": "oldCellPhone",
      "placeholder": "Digite o novo celular",
      "maxlength": "14"
    },
    domProps: {
      "value": (_vm.oldCellPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldCellPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("oldCellPhone")) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('newPhone')
    }
  }, [_c('label', {
    attrs: {
      "for": "chooseEmailId"
    }
  }, [_vm._v("Confirmar novo celular")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-plate"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|cell'),
      expression: "'required|cell'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCellPhone),
      expression: "newCellPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "phone",
      "name": "newPhone",
      "placeholder": "Digite novamente o celular",
      "maxlength": "14"
    },
    domProps: {
      "value": (_vm.newCellPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCellPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("newPhone")) + "\n                ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    attrs: {
      "id": "btn-new-pass",
      "type": "submit",
      "name": "button",
      "disabled": _vm.oldCellPhone != _vm.newCellPhone
    }
  }, [_vm._v("\n                Definir novo celular\n              ")]), _vm._v(" "), _c('i', {
    staticClass: "icon-circle-right align-icon"
  })]) : _vm._e()])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "circle-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-4f8b1196!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/user-contacts-change.vue
// module id = 2122
// module chunks = 1